export const initialData = {
  descricao: '',
}
export default initialData;
